// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"iQ","image":"iR","contentContainer":"iS","mainText":"iT","subText":"iU","counter":"iV"};